import { pstyle } from "../lib/pstyle.js";

// Reached when the URL doesn't match any known route (see
// src/hooks/router.js's parsePath). Cloudflare Pages' SPA fallback already
// serves index.html (200) for any unknown path, so netdoc has to detect
// this itself instead of relying on the host to 404.
export default function NotFound({ v }) {
  return (
    <div style={pstyle("min-height:60vh; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:16px; padding:40px; text-align:center;")}>
      <h1 style={pstyle("margin:0; font-size:22px; font-weight:600;")}>Page introuvable</h1>
      <p style={pstyle("margin:0; max-width:44ch; font-size:14.5px; line-height:1.6; color:oklch(0.5 0.015 60);")}>
        Aucune page ne correspond à cette adresse.
      </p>
      <button
        onClick={v.goHome}
        style={pstyle("cursor:pointer; font-size:13.5px; border:1px solid oklch(0.9 0.01 85); border-radius:6px; padding:8px 16px; color:oklch(0.3 0.015 60); background:oklch(1 0 0);")}
      >
        Retour à l'accueil
      </button>
    </div>
  );
}
